import { ITabAction, Tabs } from "./types/tabTypes";
import {UserState} from "../../passapp-sdk/types/userTypes";

export const tabAdd = (tab: Tabs): ITabAction<any> => {
  return {
    type: "TAB_ADD",
    payload: tab,
  };
};

export const tabClose = (index: number): ITabAction<any> => {
  return {
    type: "TAB_CLOSE",
    payload: index,
  };
};

export const tabSelect = (index: string): ITabAction<any> => {
  return {
    type: "TAB_SELECT",
    payload: index,
  };
};

export const tabSetUserByIndex = (
  index: number,
  user: UserState
): ITabAction<any> => {
  return {
    type: "TAB_SET_USER",
    payload: { index, user },
  };
};

export const tabSetUsersByIndex = (
  index: number,
  user: UserState[]
): ITabAction<any> => {
  return {
    type: "TAB_SET_USER_MULTIPLE_EXIT",
    payload: { index, user },
  };
};

export const tabShowLimit = (value: boolean): ITabAction<any> => {
  return {
    type: "TAB_SHOW_LIMIT",
    payload: value,
  };
};
export const tabSelectWithWarning = (value: boolean): ITabAction<any> => {
  return {
    type: "TAB_SELECT_WITH_WARNING",
    payload: value,
  };
};
